import React from 'react'
import CSS from './BGParticles.module.css'
import MongoDBIcon from '../../assets/mongodb.svg'

function BGParticles() {
    return (
        <div className={CSS.particle_container}>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
            <div className={`${CSS.particle} ${CSS.nobg}`}>
                <img width={30} src={MongoDBIcon} />
            </div>
        </div>
    )
}

export default BGParticles
